import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
} from "@mui/material";
import React from "react";
import { AdminListContext } from "../../context/adminListContext";
import AdminListProps from "../../interface/adminListProps";
import UserSearchProps from "../../interface/userSearchProps";
import RenderUserSearch from "./renderUserSearch";

const AddAdminDialog = (): React.JSX.Element => {
  const {
    adminList,
    setAddAdmin,
    makeUserToAdmin,
  }: {
    adminList: AdminListProps;
    setAddAdmin: React.Dispatch<React.SetStateAction<boolean>>;
    makeUserToAdmin: (userId: number) => Promise<void>;
  } = React.useContext(AdminListContext);

  const [userSearch, setUserSearch] = React.useState<UserSearchProps>({
    loading: false,
    searchString: "",
    searchResults: [],
    selectedUser: null,
  });

  const selectedUserIsAlreadyAdmin: boolean = adminList.data.some(
    (admin) => admin.userId === userSearch.selectedUser?.participantId
  );

  return (
    <Dialog
      open
      fullWidth
      maxWidth="sm"
      onClose={() => setAddAdmin(false)}
      aria-labelledby="add-admin"
    >
      <DialogTitle id="add-admin">Admin hinzufügen</DialogTitle>

      <Divider />

      {/* the option list renders inside the dialog, so it needs room to open without scrolling */}
      <DialogContent sx={{ minHeight: 360 }}>
        <DialogContentText sx={{ mb: 3 }}>
          Bestehende Nutzer:innen erhalten hier zusätzlich die Admin-Rechte. Es
          wird kein neuer Zugang angelegt.
        </DialogContentText>

        <Grid container spacing={2}>
          <Grid item xs={12}>
            <RenderUserSearch
              userSearch={userSearch}
              setUserSearch={setUserSearch}
            />
          </Grid>

          {selectedUserIsAlreadyAdmin && (
            <Grid item xs={12}>
              <DialogContentText color="error">
                Diese:r Nutzer:in ist bereits Admin.
              </DialogContentText>
            </Grid>
          )}
        </Grid>
      </DialogContent>

      <Divider />

      <DialogActions
        sx={{
          display: "flex",
          justifyContent: "space-between",
          padding: 2,
        }}
      >
        <Button onClick={() => setAddAdmin(false)} color="primary">
          Abbrechen
        </Button>

        <Button
          disabled={!userSearch.selectedUser || selectedUserIsAlreadyAdmin}
          onClick={() => {
            if (!userSearch.selectedUser) return;

            makeUserToAdmin(userSearch.selectedUser.participantId);
          }}
          variant="contained"
          color="primary"
        >
          Zum Admin machen
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddAdminDialog;
